import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';

class ModulesAction extends ActionBasic<ModulesState> {
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/RightPopUps/Modules.Action.ts